uic-check-list {
  background-color: var(--uic-check-list-background-color);
  box-sizing: border-box;
  display: block;
  height: 100%;
  padding: 0;

  .uic-check-list__scrollpanel {
    height: 100%;
  }
}
